import "../../../../.cache/static-styles-react/build-javascript/compiled.js";
/** @jsxRuntime automatic @jsxImportSource @terraindigital/static-styles-react */
import { cssRef as _cssRef, mergeComponentProps as _mergeComponentProps, mergeProps as _mergeProps } from "@terraindigital/static-styles-react";
const _staticStyles = _cssRef("styled-phone-block__phonectacolset-1ocxh7", {
  display: "flex",
  position: "relative",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
  height: "auto",
  width: "auto"
});
const _staticStyles2 = _cssRef("styled-phone-block__phonectatypography-09qs8t", {
  textAlign: "right",
  whiteSpace: "nowrap",
  "& span": {
    lineHeight: 1.1
  },
  "@media (max-width: 1200px)": {
    fontSize: "12px",
    "& span": {
      display: "block",
      lineHeight: 1.2
    }
  }
});
const _staticStyles3 = _cssRef("styled-phone-block__emergencytagline-34mmaf", {
  ".is-std &": {
    "@media (max-width: 1300px)": {
      display: "none"
    }
  }
});
import React from 'react';
import Typography from '../../primitives/typography';
import ColSet from '../../primitives/grid/col-set';
import StyledPhoneNumber from './styled-phone-number';
import type { DropdownMenuProps } from './styled-dropdown';
import formatPhoneLink from '../../utils/format-phone-link';
import { breakpoints } from '../../primitives/tokens';
import { EMERGENCY_TAGLINE } from './utils';
export const phoneCtaColSet = _staticStyles;
export const phoneCtaTypography = _staticStyles2;
const emergencyTagline = _staticStyles3;
const StyledPhoneBlock = ({
  text,
  phoneNumber,
  phoneDisplay
}: DropdownMenuProps): JSX.Element => <ColSet {..._mergeComponentProps({
  breakpoints: {
    dt: {
      between: 10
    }
  },
  css: phoneCtaColSet
})}>
        <Typography {..._mergeComponentProps({
    fontSize: "sm",
    css: phoneCtaTypography
  })}>
            <span {..._mergeProps({
      css: text === EMERGENCY_TAGLINE && emergencyTagline
    })}>{text}</span>
            {phoneNumber && <StyledPhoneNumber dialNumber={phoneNumber || phoneDisplay}>
                    {formatPhoneLink(phoneNumber || phoneDisplay)}
                </StyledPhoneNumber>}
        </Typography>
    </ColSet>;
export default StyledPhoneBlock;